import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc'

dayjs.locale('pt-br')
dayjs.extend(utc)

const strToLowerUcFirst = value => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()

const toUnixTimestamp = (strDate) => {
  const dateParts = strDate.split('/')
  const fDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`

  return dayjs(fDate).unix()
}

const formatDocument = (document) => {
  if (document && document.length === 11) {
    const cpfMask = /(\d{3})(\d{3})(\d{3})(\d{2})/
    return document.replace(cpfMask, '$1.$2.$3-$4')
  }

  if (document && document.length === 14) {
    const cnpjMask = /([\dA-Z]{2})([\dA-Z]{3})([\dA-Z]{3})([\dA-Z]{4})(\d{2})/i
    return document.toUpperCase().replace(cnpjMask, '$1.$2.$3/$4-$5')
  }

  return document
}

const nameIcon = (name) => {
  const nameArray = name.split(' ')
  return nameArray[0].substr(0, 1).toUpperCase() + nameArray[nameArray.length - 1].substr(0, 1).toUpperCase()
}

const formatDate = (date) => {
  if (!date) return ''
  return dayjs(date).format('DD/MMM/YYYY')
}

const currencyFormat = (value) => Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)

export {
  currencyFormat,
  formatDate,
  formatDocument,
  nameIcon,
  strToLowerUcFirst,
  toUnixTimestamp
}
